import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import { baseColors } from "@Constants/baseStyles"
import { handleSetColor } from "@Screens/FollowUp/Goals/Goal.Utils"
import { Ionicons } from "@expo/vector-icons"
import React from "react"
import { StyleSheet, TouchableOpacity, View } from "react-native"
import { Badge, ProgressBar } from "react-native-paper"

export const GoalCardItem = (props) => {
    const {
        totalTimeValidated,
        currentTimeValidated,
        title,
        badge,
        badgeBgColor,
        badgeTextColor,
        onPress,
        disabled,
        description,
        numTimeValidation,
        isDone
    } = props

    const isOneTime = numTimeValidation === 1

    if (isOneTime) {
        return (
            <TouchableOpacity
                disabled={disabled}
                activeOpacity={0.6}
                onPress={() => onPress && onPress()}
                style={styles.container}
            >
                <View
                    style={{
                        backgroundColor: baseColors.green.light,
                        paddingVertical: 10,
                        paddingHorizontal: 10,
                        borderRadius: 5
                    }}
                >
                    <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                        {isDone && (
                            <View
                                style={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: 20,
                                    width: 20,
                                    backgroundColor: handleSetColor(currentTimeValidated),
                                    borderRadius: 10,
                                    marginRight: 10,
                                    marginTop: 10
                                }}
                            />
                        )}

                        <View style={{ flex: 3 / 4, justifyContent: "center", alignItems: "flex-start" }}>
                            <OpenSansText>{description}</OpenSansText>
                        </View>

                        <View style={styles.badgeStyle}>
                            <OpenSansText
                                style={{ fontWeight: 700 }}
                                color={badgeTextColor || baseColors.orange.primary}
                            >
                                {badge}
                            </OpenSansText>
                        </View>
                    </View>
                </View>
            </TouchableOpacity>
        )
    }

    return (
        <TouchableOpacity
            disabled={disabled}
            activeOpacity={0.6}
            onPress={() => onPress && onPress()}
            style={styles.container}
        >
            <View style={styles.content}>
                <View style={{ flexDirection: "row", justifyContent: "space-between", marginBottom: 20 }}>
                    <View style={{ flex: 3 / 4 }}>
                        <OpenSansText>{`${totalTimeValidated} semaine${
                            totalTimeValidated > 1 ? "s" : ""
                        } pour valider cet objectif`}</OpenSansText>
                    </View>

                    <View
                        style={[
                            styles.badgeStyle,
                            {
                                flex: 1.5 / 4,
                                backgroundColor: badgeBgColor || baseColors.white,
                                alignItems: "center"
                            }
                        ]}
                    >
                        <OpenSansText fontWeight="bold" color={badgeTextColor || baseColors.orange.primary}>
                            {badge}
                        </OpenSansText>
                    </View>
                </View>

                <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                    <View style={{ flex: 1 }}>
                        <OpenSansText fontWeight="bold" color={baseColors.textBlack}>
                            {description}
                        </OpenSansText>
                    </View>

                    <Ionicons color={baseColors.green.primary} size={25} name={"chevron-forward"} />
                </View>

                <Spacer height={10} />

                <ProgressBar
                    style={styles.progress}
                    theme={{
                        roundness: 10,
                        colors: {
                            primary: baseColors.green.dark
                        }
                    }}
                    backgroundColor={"white"}
                    progress={currentTimeValidated / totalTimeValidated}
                />
            </View>
        </TouchableOpacity>
    )
}

const styles = StyleSheet.create({
    container: { elevation: 3, marginBottom: 10 },
    progress: { height: 5, borderRadius: 10, backgroundColor: baseColors.grey },
    content: {
        // height: 204,
        borderRadius: 10,
        padding: 18,
        backgroundColor: baseColors.green.light
    },
    badgeStyle: {
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 50,
        height: 40,
        backgroundColor: baseColors.white,
        paddingVertical: 10,
        flex: 1.5 / 4
    }
})
